// extracted by mini-css-extract-plugin
export default {"button":"copy_button__9gqNT","button--danger":"copy_button--danger__Q17kJ","button__icon":"copy_button__icon__x2K1l"};